import {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {getAdyenStatus} from '../../../actions/adyen/browser';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import {PAYMENT_STATUS} from './consts';

const DELAY = 1500;

export const useAdyenStatusWaiting = ({
    paymentSessionId,
    languageCode,
    dispatch,
    initData,
    initError
}) => {
    const history = useHistory();

    const [data, setData] = useState(initData);
    const [error, setError] = useState(initError);
    const isTransactionCompleted = transferData => transferData?.paymentStatus === PAYMENT_STATUS.DONE;

    const getNewData = () => getAdyenStatus({
        paymentSessionId,
        languageCode
    })
        .then(newData => {
            setData(newData);
            if (!isTransactionCompleted(newData)) {
                setTimeout(getNewData, DELAY);
            }
        })
        .catch(err => {
            setError(err);
            setTimeout(getNewData, DELAY);
        });

    useEffect(() => {
        history.replace({
            pathname: window.location.pathname,
            search: ''
        });

        if (error || !isTransactionCompleted(data)) {
            getNewData();
        }
    }, []);

    useEffect(() => {
        if (error) {
            dispatch(genericErrorHasOccurred(true));
        }
    }, [error, dispatch]);

    useEffect(() => {
        if (data?.paymentStatus === PAYMENT_STATUS.DONE) {
            window.location.assign(data.redirectUrl);
        }
    }, [data]);


    return {
        data,
        error
    };
};
